module.exports = __webpack_public_path__ + "static/wordmark_inverted-403e2f25bf175a54b3e759d3aeea4a4f.png";